import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { pakBoundryLayer } from '../../common/functions/pak_boundry.function';
import RefreshMap from '../../common/components/refresh_map_component';
import './fiber-pop-popup.css';

mapboxgl.accessToken = process.env.REACT_APP_PUBLIC_MAP_BOX_GL_ACCESS_TOKEN;

// Mock data - no longer used, kept for reference only
/*
const fiberData = [
  {
    fiber_pop: 'RUR4991',
    latest_status: 'Fiber Node',
    ran_region: 'Central A',
    foo_region: 'C-A',
    city_name: 'Rural',
    type: 'LDI',
    telecom_region: 'CTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'RUR4991__H_SHWAddaShareenwala',
    latt: 30.5429,
    long: 73.0673,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'DNG3509',
    latest_status: 'Fiber Node',
    ran_region: 'North',
    foo_region: 'North',
    city_name: 'Dinga',
    type: 'LDI',
    telecom_region: 'GTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'DNG3509__H_MaladChwk',
    latt: 32.6401,
    long: 73.7251,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'ALC3447',
    latest_status: 'Fiber Node',
    ran_region: 'North',
    foo_region: 'North',
    city_name: 'Alipur Chatha',
    type: 'LDI',
    telecom_region: 'GTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'ALC3447__H_IkalGarhAlipurChat',
    latt: 32.2646,
    long: 73.8196,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'OKR4561',
    latest_status: 'Fiber Node',
    ran_region: 'Central A',
    foo_region: 'C-A',
    city_name: 'Okara',
    type: 'LDI',
    telecom_region: 'CTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'OKR4561__H_BasharatPark',
    latt: 30.8003,
    long: 73.4451,
    technology: 'IPRAN-OTN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'SKY9499',
    latest_status: 'Fiber Node',
    ran_region: 'North',
    foo_region: 'North',
    city_name: 'Sarokay',
    type: 'LDI',
    telecom_region: 'GTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'SKY9499__S_Saroki_Chowk_2J3777',
    latt: 32.35523,
    long: 73.98531,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'HWY9737',
    latest_status: 'Fiber Node',
    ran_region: 'North',
    foo_region: 'North',
    city_name: 'Highway',
    type: 'LDI',
    telecom_region: 'GTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'HWY9737__P_MoreAmenabad2',
    latt: 32.05529,
    long: 74.20696,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'SHW3601',
    latest_status: 'Fiber Node',
    ran_region: 'Central A',
    foo_region: 'C-A',
    city_name: 'Sahiwal',
    type: 'Metro',
    telecom_region: 'CTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'SHW3601__H_TariqBinZiad',
    latt: 30.67315,
    long: 73.11313,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'PSR0269',
    latest_status: 'Fiber Node',
    ran_region: 'North',
    foo_region: 'North',
    city_name: 'rural',
    type: 'LDI',
    telecom_region: 'GTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'PSR0269__S_MainRdPasroor',
    latt: 32.27449,
    long: 74.6617,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'SKT0020',
    latest_status: 'Fiber Node',
    ran_region: 'North',
    foo_region: 'North',
    city_name: 'Sialkot',
    type: 'Metro',
    telecom_region: 'GTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'SKT0020__H_QilaSialkot',
    latt: 32.4933,
    long: 74.5409,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'LHR3054',
    latest_status: 'MSC Location',
    ran_region: 'Central A',
    foo_region: 'C-A',
    city_name: 'Lahore',
    type: 'Metro',
    telecom_region: 'LTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'LHR3054__H_LHRMunnuChowk',
    latt: 31.3968,
    long: 74.2335,
    technology: 'IPRAN-OTN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'LHR0239',
    latest_status: 'Fiber Node/BIZ',
    ran_region: 'Central A',
    foo_region: 'C-A',
    city_name: 'Lahore',
    type: 'Metro',
    telecom_region: 'LTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'LHR0239__H_ShadmanMarket',
    latt: 31.5386,
    long: 74.3292,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'SHK0819',
    latest_status: 'Fiber Node',
    ran_region: 'Central A',
    foo_region: 'C-A',
    city_name: 'Sheikhupura',
    type: 'Metro',
    telecom_region: 'CTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'SHK0819__H_CivilinesSHK',
    latt: 31.7102,
    long: 73.97,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'GUJ0723',
    latest_status: 'Fiber Node',
    ran_region: 'North',
    foo_region: 'North',
    city_name: 'Gujranwala',
    type: 'Metro',
    telecom_region: 'GTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'GUJ0723__H_ShahinAbad',
    latt: 32.1867,
    long: 74.1802,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'GUJ0006',
    latest_status: 'Fiber Node',
    ran_region: 'North',
    foo_region: 'North',
    city_name: 'Gujranwala',
    type: 'Metro',
    telecom_region: 'GTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'GUJ0006__H_Ghalla',
    latt: 32.1675,
    long: 74.1863,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'LHR0191',
    latest_status: 'Fiber Node',
    ran_region: 'Central A',
    foo_region: 'C-A',
    city_name: 'Lahore',
    type: 'Metro',
    telecom_region: 'LTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'LHR0191__H_FirdusMarket',
    latt: 31.5014,
    long: 74.3491,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'RWD3061',
    latest_status: 'Fiber Node',
    ran_region: 'Central A',
    foo_region: 'C-A',
    city_name: 'Raiwind',
    type: 'LDI',
    telecom_region: 'LTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'RWD3061__H_LHRRailwayRaiwand_N',
    latt: 31.2504,
    long: 74.22,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'HWY9394',
    latest_status: 'Fiber Node',
    ran_region: 'North',
    foo_region: 'North',
    city_name: 'Highway',
    type: 'LDI',
    telecom_region: 'GTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'HWY9394__S_HusaykiWarid_25414',
    latt: 31.92338,
    long: 73.38124,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'LHR0129',
    latest_status: 'Fiber Node/BIZ',
    ran_region: 'Central A',
    foo_region: 'C-A',
    city_name: 'Lahore',
    type: 'Metro',
    telecom_region: 'LTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'LHR0129__H_Chouburgi',
    latt: 31.5542,
    long: 74.3056,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  {
    fiber_pop: 'HWY9673',
    latest_status: 'Fiber Node',
    ran_region: 'Central A',
    foo_region: 'C-A',
    city_name: 'Highway',
    type: 'LDI',
    telecom_region: 'CTR',
    ran_site: 'Yes',
    ola_location: '',
    site_name: 'HWY9673__P_Sheikhupura_East',
    latt: 31.71092,
    long: 74.01967,
    technology: 'IPRAN',
    vendor: 'Huawei',
    route: 'RING',
  },
  // ...the rest of the rows can be appended similarly
];
*/

const FiberPopListMap = ({ selectedFiberPop, setMapRef, fiberPopData: fiberPopDataProp = [] }) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const animationTimeoutRef = useRef(null);
  const popMarkers = useRef([]);
  const markersByFiberPop = useRef(new Map()); // Map to store markers by fiber_pop name
  const highlightedMarker = useRef(null);
  const hiddenRegularMarker = useRef(null); // Store reference to hidden regular marker
  const highlightedPopup = useRef(null);
  const currentPopup = useRef(null);
  const processedDataRef = useRef(null);
  const clearHighlightRef = useRef(null); // Store clearHighlight function reference
  const controllerRef = useRef(null);
  const requestManagerRef = useRef(new Map()); // Track all active requests
  const zoomHandlerRef = useRef(null); // Store zoom handler for proper cleanup
  const [lng, setLng] = useState(69.3451);
  const [lat, setLat] = useState(30.3753);
  const [zoom, setZoom] = useState(5);
  const [fiberPopData, setFiberPopData] = useState(fiberPopDataProp || []);

  // Helper function to convert coordinates (handles both number and string)
  const parseCoordinate = (value) => {
    if (value === null || value === undefined || value === '') {
      return NaN;
    }
    // If it's already a number, return it
    if (typeof value === 'number') {
      return value;
    }
    // If it's a string, try to parse it
    if (typeof value === 'string') {
      // Remove any whitespace
      const cleaned = value.trim();
      // Try to parse as float
      const parsed = parseFloat(cleaned);
      return isNaN(parsed) ? NaN : parsed;
    }
    return NaN;
  };

  // Create marker element for POP (dot style like IpranMap)
  const createPopMarkerElement = (isHighlighted = false) => {
    const el = document.createElement('div');
    el.className = 'fiber-pop-marker';

    // Calculate circle size similar to IpranMap (3.8 / 1.8 ≈ 2.1px base)
    const baseRadius = 3.8 / 1.8;
    const radius = isHighlighted ? baseRadius * 1.5 : baseRadius;
    const size = radius * 2;

    el.style.width = `${size}px`;
    el.style.height = `${size}px`;
    el.style.borderRadius = '50%';
    el.style.cursor = 'pointer';
    el.style.display = 'flex';
    el.style.alignItems = 'center';
    el.style.justifyContent = 'center';
    el.style.transition = 'all 0.3s ease';
    el.style.zIndex = isHighlighted ? 1000 : 1;

    // Use colors similar to IpranMap sites layer
    // Regular: #02367b (same as IpranMap sites)
    // Highlighted: #BD1D23 (red for highlighted)
    const circleColor = isHighlighted ? '#BD1D23' : '#02367b';
    const strokeColor = isHighlighted ? '#BD1D23' : '#02367b';
    const strokeWidth = isHighlighted ? (2.5 / 1.8) * 1.5 : 2.5 / 1.8;
    const strokeOpacity = isHighlighted ? 0.6 : 0.4;

    el.style.backgroundColor = circleColor;
    el.style.border = `${strokeWidth}px solid ${strokeColor}`;
    el.style.opacity = strokeOpacity;
    el.style.boxShadow = isHighlighted
      ? '0 2px 6px rgba(189, 29, 35, 0.6)'
      : '0 1px 4px rgba(0,0,0,0.3)';

    return el;
  };

  // Determine the best anchor position for popup based on marker position on screen
  const getPopupAnchor = (lng, lat) => {
    if (!map.current) {
      return 'bottom'; // Default to bottom if map not ready
    }

    try {
      // Convert lat/lng to pixel coordinates
      const point = map.current.project([lng, lat]);
      const mapHeight = map.current.getContainer().offsetHeight;

      // If marker is in the top 30% of the screen, use 'top' anchor
      // Otherwise use 'bottom' anchor
      const topThreshold = mapHeight * 0.3;

      if (point.y < topThreshold) {
        return 'top';
      }
      return 'bottom';
    } catch (error) {
      console.warn('Error determining popup anchor:', error);
      return 'bottom'; // Default to bottom on error
    }
  };

  // Generate compact popup HTML with two fields per row and aligned columns
  const generatePopupHtml = (pop, isHighlighted = false, coordinates = null) => {
    const borderColor = isHighlighted ? '#BD1D23' : '#3b82f6';

    // Extract coordinates - can come from pop.latt/long or from coordinates parameter
    let latStr = '--';
    let lngStr = '--';
    if (coordinates && Array.isArray(coordinates) && coordinates.length >= 2) {
      latStr = parseFloat(coordinates[1]).toFixed(4);
      lngStr = parseFloat(coordinates[0]).toFixed(4);
    } else if (pop.latt !== undefined && pop.long !== undefined) {
      latStr = parseFloat(pop.latt).toFixed(4);
      lngStr = parseFloat(pop.long).toFixed(4);
    }

    return `
      <div style="padding: 10px; min-width: 300px; max-width: 450px; font-family: Arial, sans-serif; box-sizing: border-box;">
        <h3 style="margin: 0 0 10px 0; padding-bottom: 6px; border-bottom: 2px solid ${borderColor}; color: #1f2937; font-size: 15px; font-weight: 600; word-wrap: break-word;">
          ${pop.fiber_pop || '--'}
        </h3>
        <div style="display: grid; grid-template-columns: minmax(90px, auto) 1fr minmax(100px, auto) 1fr; gap: 6px 12px; font-size: 12px; max-height: 350px; overflow-y: auto; align-items: center;">
          <span style="color: #6b7280; font-weight: 500; white-space: nowrap;">Status:</span>
          <span style="color: #1f2937;">${pop.latest_status || '--'}</span>
          <span style="color: #6b7280; font-weight: 500; white-space: nowrap;">RAN Region:</span>
          <span style="color: #1f2937;">${pop.ran_region || '--'}</span>
          
          <span style="color: #6b7280; font-weight: 500; white-space: nowrap;">FOO Region:</span>
          <span style="color: #1f2937;">${pop.foo_region || '--'}</span>
          <span style="color: #6b7280; font-weight: 500; white-space: nowrap;">City:</span>
          <span style="color: #1f2937;">${pop.city_name || '--'}</span>
          
          <span style="color: #6b7280; font-weight: 500; white-space: nowrap;">Type:</span>
          <span style="color: #1f2937;">${pop.type || '--'}</span>
          <span style="color: #6b7280; font-weight: 500; white-space: nowrap;">Telecom Region:</span>
          <span style="color: #1f2937;">${pop.telecom_region || '--'}</span>
          
          <span style="color: #6b7280; font-weight: 500; white-space: nowrap;">RAN Site:</span>
          <span style="color: #1f2937;">${pop.ran_site || '--'}</span>
          <span style="color: #6b7280; font-weight: 500; white-space: nowrap;">Technology:</span>
          <span style="color: #1f2937;">${pop.technology || '--'}</span>
          
          <span style="color: #6b7280; font-weight: 500; white-space: nowrap;">Vendor:</span>
          <span style="color: #1f2937;">${pop.vendor || '--'}</span>
          <span style="color: #6b7280; font-weight: 500; white-space: nowrap;">Route:</span>
          <span style="color: #1f2937;">${pop.route || '--'}</span>
          
          <span style="color: #6b7280; font-weight: 500; white-space: nowrap;">Coordinates:</span>
          <span style="color: #1f2937; font-size: 11px;">${latStr}, ${lngStr}</span>
          <span></span>
          <span></span>
        </div>
        <div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #e5e7eb;">
          <div style="color: #6b7280; font-weight: 500; font-size: 12px; margin-bottom: 4px;">Site Name:</div>
          <div style="color: #1f2937; font-size: 12px; word-wrap: break-word;">${pop.site_name || '--'}</div>
        </div>
      </div>
    `;
  };

  // Update local state when prop changes (data comes from parent)
  // This ensures data persists when switching views and updates when new data arrives
  useEffect(() => {
    if (fiberPopDataProp) {
      setFiberPopData(fiberPopDataProp);
      // Reset processed data ref when new data arrives to force layer update
      if (fiberPopDataProp.length > 0) {
        processedDataRef.current = null;
      }
    }
  }, [fiberPopDataProp]);

  // Remove existing markers (optimized for performance)
  // Remove existing layers (native Mapbox GL layers)
  const removePopLayers = () => {
    if (!map.current) {
      return;
    }

    // Remove event listeners
    map.current.off('mouseenter', 'fiberPopLayers');
    map.current.off('mouseleave', 'fiberPopLayers');
    map.current.off('mouseenter', 'fiberPopLayersHighlighted');
    map.current.off('mouseleave', 'fiberPopLayersHighlighted');

    // Remove layers
    if (map.current.getLayer('fiberPopLayers')) {
      map.current.removeLayer('fiberPopLayers');
    }
    if (map.current.getLayer('fiberPopLayersHighlighted')) {
      map.current.removeLayer('fiberPopLayersHighlighted');
    }

    // Remove custom images
    if (map.current.hasImage('fiber-pop-tower')) {
      map.current.removeImage('fiber-pop-tower');
    }
    if (map.current.hasImage('fiber-pop-tower-highlighted')) {
      map.current.removeImage('fiber-pop-tower-highlighted');
    }

    // Remove source
    if (map.current.getSource('fiberPopLayers')) {
      map.current.removeSource('fiberPopLayers');
    }

    // Remove popups
    if (currentPopup.current) {
      currentPopup.current.remove();
      currentPopup.current = null;
    }
    if (highlightedPopup.current) {
      highlightedPopup.current.remove();
      highlightedPopup.current = null;
    }
  };

  // Clear highlighted layer (using layer filter instead of markers)
  const clearHighlight = () => {
    console.log('[FiberPopMap] clearHighlight called');

    if (!map.current || !map.current.getSource('fiberPopLayers')) {
      // Close popups even if source doesn't exist
      if (highlightedPopup.current) {
        highlightedPopup.current.remove();
        highlightedPopup.current = null;
      }
      if (currentPopup.current) {
        currentPopup.current.remove();
        currentPopup.current = null;
      }
      return;
    }

    // Update all features to not be highlighted
    const source = map.current.getSource('fiberPopLayers');
    if (source && source._data) {
      const data = source._data;
      if (data.features) {
        data.features.forEach((feature) => {
          feature.properties.highlighted = false;
        });
        // Update the source data to trigger layer refresh
        source.setData(data);
      }
    }

    // Close highlighted popup
    if (highlightedPopup.current) {
      try {
        highlightedPopup.current.remove();
        console.log('Highlighted popup removed');
      } catch (error) {
        console.warn('Error removing highlighted popup:', error);
      }
      highlightedPopup.current = null;
    }
    // Also close any open hover popups
    if (currentPopup.current) {
      try {
        currentPopup.current.remove();
      } catch (error) {
        console.warn('Error removing current popup:', error);
      }
      currentPopup.current = null;
    }
  };

  // Store clearHighlight in ref so it's always accessible
  clearHighlightRef.current = clearHighlight;

  // Utility function to cancel all active requests
  const cancelAllRequests = () => {
    console.log('[FiberPopMap] Cancelling all active requests...');

    if (requestManagerRef.current) {
      const requestCount = requestManagerRef.current.size;
      console.log(`[FiberPopMap] Found ${requestCount} active requests to cancel`);

      requestManagerRef.current.forEach((controller, requestId) => {
        if (controller && !controller.signal.aborted) {
          console.log(`[FiberPopMap] Cancelling request: ${requestId}`);
          controller.abort();
        }
      });
      requestManagerRef.current.clear();
    }

    if (controllerRef.current && !controllerRef.current.signal.aborted) {
      console.log('[FiberPopMap] Cancelling main controller');
      controllerRef.current.abort();
    }

    console.log('[FiberPopMap] All requests cancelled');
  };

  // Utility function to add a request to the manager
  const addRequestToManager = (requestId, controller) => {
    if (requestManagerRef.current) {
      requestManagerRef.current.set(requestId, controller);
      console.log(`[FiberPopMap] Added request to manager: ${requestId}`);
    }
  };

  // Utility function to remove a request from the manager
  const removeRequestFromManager = (requestId) => {
    if (requestManagerRef.current) {
      requestManagerRef.current.delete(requestId);
      console.log(`[FiberPopMap] Removed request from manager: ${requestId}`);
    }
  };

  // Cleanup function similar to IpranMap (optimized for smooth animation)
  const clearAll = () => {
    if (!map.current) {
      return;
    }

    // Remove popups immediately (lightweight operation)
    if (currentPopup.current) {
      currentPopup.current.remove();
      currentPopup.current = null;
    }
    if (highlightedPopup.current) {
      highlightedPopup.current.remove();
      highlightedPopup.current = null;
    }

    // Start smooth animation first (before heavy operations)
    map.current.flyTo({
      center: [69.3451, 30.3753],
      zoom: 5,
      bearing: 0,
      duration: 2000,
      essential: true, // This animation is essential and should not be interrupted
      easing: (t) => {
        // Ease-out cubic function for smooth deceleration
        return 1 - Math.pow(1 - t, 3);
      },
    });

    // Defer heavy operations to not block animation
    // Use requestAnimationFrame to ensure smooth animation
    requestAnimationFrame(() => {
      // Cancel all active requests (non-blocking)
      cancelAllRequests();

      // Clear layers after a short delay to let animation start
      setTimeout(() => {
        removePopLayers();
      }, 100);
    });
  };

  // Highlight a specific layer by fiberpop name (using layer filter)
  const highlightMarker = (fiberPopName) => {
    if (!map.current || !fiberPopData.length || !map.current.getSource('fiberPopLayers')) {
      return;
    }

    // Clear previous highlight first
    clearHighlight();

    // Find the fiberpop in data
    const foundPop = fiberPopData.find(
      (pop) => pop.fiber_pop?.toLowerCase() === fiberPopName?.toLowerCase()
    );

    if (foundPop) {
      const lng = parseCoordinate(foundPop.long);
      const lat = parseCoordinate(foundPop.latt);

      if (!isNaN(lng) && !isNaN(lat)) {
        // Update the source data to mark this feature as highlighted
        const source = map.current.getSource('fiberPopLayers');
        if (source && source._data) {
          const data = source._data;
          if (data.features) {
            data.features.forEach((feature) => {
              if (feature.properties.fiber_pop?.toLowerCase() === fiberPopName?.toLowerCase()) {
                feature.properties.highlighted = true;
              } else {
                feature.properties.highlighted = false;
              }
            });
            // Update the source data to trigger layer refresh
            source.setData(data);
          }
        }

        // Create popup HTML using compact layout
        const popupHtml = generatePopupHtml(foundPop, true, [lng, lat]);

        // Determine best anchor position based on marker location
        const anchor = getPopupAnchor(lng, lat);

        // Create initial popup (shown when marker is highlighted)
        const popup = new mapboxgl.Popup({
          closeButton: true,
          offset: 25,
          maxWidth: '480px',
          className: 'fiber-pop-popup',
          anchor: anchor,
        })
          .setLngLat([lng, lat])
          .setHTML(popupHtml)
          .addTo(map.current);

        // Store reference to highlighted popup
        highlightedPopup.current = popup;

        // Ensure popup has high z-index after it's added to DOM
        setTimeout(() => {
          const popupElement = popup.getElement();
          if (popupElement) {
            popupElement.style.zIndex = '10001';
          }
        }, 0);

        // Fly to the highlighted location
        map.current.flyTo({
          center: [lng, lat],
          zoom: 12,
          duration: 2000,
          essential: true,
        });

        console.log('Highlighted layer for:', foundPop.fiber_pop, 'at', [lng, lat]);
      }
    }
  };

  // Convert fiberPopData to GeoJSON format
  const convertToGeoJSON = (data) => {
    const features = data
      .map((pop) => {
        const lng = parseCoordinate(pop.long);
        const lat = parseCoordinate(pop.latt);

        // Skip if coordinates are invalid
        if (isNaN(lng) || isNaN(lat)) {
          console.warn(`Invalid coordinates for POP: ${pop.fiber_pop}`, {
            originalLong: pop.long,
            originalLatt: pop.latt,
            parsedLng: lng,
            parsedLat: lat,
          });
          return null;
        }

        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [lng, lat],
          },
          properties: {
            fiber_pop: pop.fiber_pop || '--',
            latest_status: pop.latest_status || '--',
            ran_region: pop.ran_region || '--',
            foo_region: pop.foo_region || '--',
            city_name: pop.city_name || '--',
            type: pop.type || '--',
            telecom_region: pop.telecom_region || '--',
            ran_site: pop.ran_site || '--',
            ola_location: pop.ola_location || '--',
            site_name: pop.site_name || '--',
            technology: pop.technology || '--',
            vendor: pop.vendor || '--',
            route: pop.route || '--',
            highlighted: false, // Default to not highlighted
          },
        };
      })
      .filter(Boolean); // Remove null entries

    return {
      type: 'FeatureCollection',
      features,
    };
  };

  // Tower icon – same SVG as Network Layer Visualization (Mapbox symbol, smooth display/movement)
  const createTowerSvgIcon = (color) => {
    const maskId = `fiberpop_tower_mask_${Math.random().toString(36).substr(2, 9)}`;
    return `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="${maskId}" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <path d="M0 1.90735e-06H24V24H0V1.90735e-06Z" fill="white"/>
        </mask>
        <g mask="url(#${maskId})">
          <path d="M5.3916 23.2915H18.6104" stroke="${color}" stroke-width="1.40625" stroke-miterlimit="22.926" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.999 6.83454L12.2344 6.90396L16.0791 23.2915H7.91895L11.7778 6.84382L11.999 6.83454Z" stroke="${color}" stroke-width="1.40625" stroke-miterlimit="22.926" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.999 6.83447C12.8262 6.83447 13.501 6.15975 13.501 5.3325C13.501 4.5053 12.8262 3.83058 11.999 3.83058C11.1718 3.83058 10.4971 4.5053 10.4971 5.3325C10.4971 6.15975 11.1718 6.83447 11.999 6.83447Z" stroke="${color}" stroke-width="1.40625" stroke-miterlimit="22.926" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.56957 7.91162C8.0104 7.16809 7.70801 6.26293 7.70801 5.33256C7.70801 4.34097 8.05141 3.38003 8.67987 2.61301" stroke="${color}" stroke-width="1.40625" stroke-miterlimit="22.926" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.50538 9.79883C5.4792 8.53653 4.91895 6.95938 4.91895 5.33258C4.91895 3.63514 5.52879 1.99414 6.63743 0.708688" stroke="${color}" stroke-width="1.40625" stroke-miterlimit="22.926" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15.4304 7.91162C15.9896 7.16809 16.292 6.26293 16.292 5.33256C16.292 4.34097 15.9485 3.38003 15.3201 2.61301" stroke="${color}" stroke-width="1.40625" stroke-miterlimit="22.926" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.4948 9.79883C18.521 8.53653 19.0813 6.95938 19.0813 5.33258C19.0813 3.63514 18.4714 1.99414 17.3628 0.708688" stroke="${color}" stroke-width="1.40625" stroke-miterlimit="22.926" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.12817 22.4001L14.9266 18.3787" stroke="${color}" stroke-width="1.40625" stroke-miterlimit="22.926" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.79443 15.324L14.9073 18.3723" stroke="${color}" stroke-width="1.40625" stroke-miterlimit="22.926" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.79443 15.324L13.6762 13.0494" stroke="${color}" stroke-width="1.40625" stroke-miterlimit="22.926" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
      </svg>
    `;
  };

  // Add tower symbol layers to map (native Mapbox GL layers)
  const addPopLayers = () => {
    console.log('addPopLayers called', {
      hasMap: !!map.current,
      dataLength: fiberPopData.length,
      isStyleLoaded: map.current?.isStyleLoaded?.(),
    });

    if (!map.current || !fiberPopData.length) {
      console.log('Skipping addPopLayers - missing map or data');
      return;
    }

    // Check if we've already processed this data
    const dataKey = JSON.stringify(fiberPopData);
    if (processedDataRef.current === dataKey) {
      console.log('Skipping addPopLayers - data already processed');
      return;
    }

    console.log('Adding tower symbol layers for', fiberPopData.length, 'POPs');
    processedDataRef.current = dataKey;
    removePopLayers();

    // Convert data to GeoJSON
    const geoJsonData = convertToGeoJSON(fiberPopData);

    // Remove existing source if it exists
    if (map.current.getSource('fiberPopLayers')) {
      map.current.removeSource('fiberPopLayers');
    }

    // Add source
    map.current.addSource('fiberPopLayers', {
      type: 'geojson',
      data: geoJsonData,
    });

    // Create SVG tower icons (same as Network Layer Visualization): regular and highlighted
    const regularTowerSvg = createTowerSvgIcon('#02367b'); // Dark blue (Fiber POP)
    const highlightedTowerSvg = createTowerSvgIcon('#BD1D23'); // App red for highlighted

    const regularSvgDataURL = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(regularTowerSvg)}`;
    const highlightedSvgDataURL = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(highlightedTowerSvg)}`;

    // Track loaded images
    let regularLoaded = false;
    let highlightedLoaded = false;

    // Function to add tower layers after images are loaded
    const addTowerLayers = () => {
      if (!map.current) {
        return;
      }

      // Only proceed if both images are loaded (or at least regular is loaded)
      if (!map.current.hasImage('fiber-pop-tower')) {
        return;
      }

      // Add regular tower symbol layer (Mapbox symbol – smooth display and movement, same as network layer)
      if (!map.current.getLayer('fiberPopLayers')) {
        map.current.addLayer({
          id: 'fiberPopLayers',
          type: 'symbol',
          source: 'fiberPopLayers',
          layout: {
            'icon-image': 'fiber-pop-tower',
            'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 1, 13, 2],
            'icon-allow-overlap': true,
            'icon-anchor': 'bottom',
          },
          filter: ['==', ['get', 'highlighted'], false],
        });
      }

      // Add highlighted tower symbol layer
      if (
        map.current.hasImage('fiber-pop-tower-highlighted') &&
        !map.current.getLayer('fiberPopLayersHighlighted')
      ) {
        map.current.addLayer({
          id: 'fiberPopLayersHighlighted',
          type: 'symbol',
          source: 'fiberPopLayers',
          layout: {
            'icon-image': 'fiber-pop-tower-highlighted',
            'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 1.2, 13, 2.2],
            'icon-allow-overlap': true,
            'icon-anchor': 'bottom',
          },
          filter: ['==', ['get', 'highlighted'], true],
        });
      }

      // Add event listeners after layers are added (only once)
      if (!map.current._fiberPopEventListenersAdded) {
        addTowerEventListeners();
        map.current._fiberPopEventListenersAdded = true;
      }
    };

    // Check if both images are loaded
    const checkImagesLoaded = () => {
      // Only proceed if map still exists
      if (!map.current) {
        return;
      }
      if (regularLoaded && highlightedLoaded) {
        addTowerLayers();
      } else if (regularLoaded) {
        // Add layers even if highlighted hasn't loaded yet
        addTowerLayers();
      }
    };

    // Load regular tower icon
    const regularImg = new Image();
    regularImg.onload = () => {
      // Check if map still exists (component might have unmounted)
      if (!map.current) {
        console.log('[FiberPopMap] Map unmounted, skipping image add');
        return;
      }
      if (!map.current.hasImage('fiber-pop-tower')) {
        map.current.addImage('fiber-pop-tower', regularImg, { pixelRatio: 2 });
      }
      regularLoaded = true;
      checkImagesLoaded();
    };
    regularImg.onerror = () => {
      console.error('Failed to load regular tower icon');
      regularLoaded = true; // Mark as loaded to proceed anyway
      // Only check if map still exists
      if (map.current) {
        checkImagesLoaded();
      }
    };
    regularImg.src = `${regularSvgDataURL}#${Date.now()}-regular`;

    // Load highlighted tower icon
    const highlightedImg = new Image();
    highlightedImg.onload = () => {
      // Check if map still exists (component might have unmounted)
      if (!map.current) {
        console.log('[FiberPopMap] Map unmounted, skipping image add');
        return;
      }
      if (!map.current.hasImage('fiber-pop-tower-highlighted')) {
        map.current.addImage('fiber-pop-tower-highlighted', highlightedImg, { pixelRatio: 2 });
      }
      highlightedLoaded = true;
      checkImagesLoaded();
    };
    highlightedImg.onerror = () => {
      console.error('Failed to load highlighted tower icon');
      highlightedLoaded = true; // Mark as loaded to proceed anyway
      // Only check if map still exists
      if (map.current) {
        checkImagesLoaded();
      }
    };
    highlightedImg.src = `${highlightedSvgDataURL}#${Date.now()}-highlighted`;

    // Add event listeners for tower layers
    const addTowerEventListeners = () => {
      // Add event listeners to change cursor style
      map.current.on('mouseenter', 'fiberPopLayers', () => {
        map.current.getCanvasContainer().style.cursor = 'pointer';
      });

      map.current.on('mouseleave', 'fiberPopLayers', () => {
        map.current.getCanvasContainer().style.cursor = '';
      });

      map.current.on('mouseenter', 'fiberPopLayersHighlighted', () => {
        map.current.getCanvasContainer().style.cursor = 'pointer';
      });

      map.current.on('mouseleave', 'fiberPopLayersHighlighted', () => {
        map.current.getCanvasContainer().style.cursor = '';
      });

      // Add hover popup on mouseenter
      map.current.on('mouseenter', 'fiberPopLayers', (e) => {
        const features = map.current.queryRenderedFeatures(e.point, {
          layers: ['fiberPopLayers'],
        });

        if (!features.length) {
          return;
        }

        const feature = features[0];
        const properties = feature.properties;
        const coordinates = feature.geometry.coordinates.slice();

        if (currentPopup.current) {
          currentPopup.current.remove();
        }

        const popupHtml = generatePopupHtml(properties, false, coordinates);
        const anchor = getPopupAnchor(coordinates[0], coordinates[1]);

        currentPopup.current = new mapboxgl.Popup({
          closeButton: false,
          offset: 25,
          maxWidth: '480px',
          className: 'fiber-pop-popup',
          anchor: anchor,
        })
          .setLngLat(coordinates)
          .setHTML(popupHtml)
          .addTo(map.current);

        // Ensure popup has high z-index
        setTimeout(() => {
          const popupElement = currentPopup.current?.getElement();
          if (popupElement) {
            popupElement.style.zIndex = '10001';
          }
        }, 0);
      });

      map.current.on('mouseleave', 'fiberPopLayers', () => {
        if (currentPopup.current) {
          currentPopup.current.remove();
          currentPopup.current = null;
        }
      });

      // Add hover popup for highlighted layer
      map.current.on('mouseenter', 'fiberPopLayersHighlighted', (e) => {
        const features = map.current.queryRenderedFeatures(e.point, {
          layers: ['fiberPopLayersHighlighted'],
        });

        if (!features.length) {
          return;
        }

        const feature = features[0];
        const properties = feature.properties;
        const coordinates = feature.geometry.coordinates.slice();

        if (currentPopup.current) {
          currentPopup.current.remove();
        }

        const popupHtml = generatePopupHtml(properties, true, coordinates);
        const anchor = getPopupAnchor(coordinates[0], coordinates[1]);

        currentPopup.current = new mapboxgl.Popup({
          closeButton: false,
          offset: 25,
          maxWidth: '480px',
          className: 'fiber-pop-popup',
          anchor: anchor,
        })
          .setLngLat(coordinates)
          .setHTML(popupHtml)
          .addTo(map.current);

        setTimeout(() => {
          const popupElement = currentPopup.current?.getElement();
          if (popupElement) {
            popupElement.style.zIndex = '10001';
          }
        }, 0);
      });

      map.current.on('mouseleave', 'fiberPopLayersHighlighted', () => {
        if (currentPopup.current) {
          currentPopup.current.remove();
          currentPopup.current = null;
        }
      });
    };

    console.log(`Total tower symbol layers will be added for ${geoJsonData.features.length} POPs`);
  };

  useEffect(() => {
    if (!map.current && mapContainer.current) {
      console.log('Initializing map...', {
        container: mapContainer.current,
        hasToken: !!mapboxgl.accessToken,
        containerDimensions: {
          width: mapContainer.current.offsetWidth,
          height: mapContainer.current.offsetHeight,
        },
      });

      // Initialize map
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/standard',
        center: [lng, lat],
        zoom: zoom,
        attributionControl: false,
        pitch: 0,
      });

      console.log('Map instance created:', map.current);

      // Add navigation controls (with compass/reset bearing button - 3 buttons total)
      map.current.addControl(new mapboxgl.NavigationControl(), 'bottom-right');

      // Track zoom and center changes (same as KMZ)
      map.current.on('moveend', () => {
        if (map.current) {
          setLng(map.current.getCenter().lng.toFixed(4));
          setLat(map.current.getCenter().lat.toFixed(4));
          setZoom(map.current.getZoom().toFixed(2));
        }
      });

      // Handle zoom changes for layer management (similar to IpranMap)
      const handleZoomChange = () => {
        if (!map.current) {
          return;
        }
        const currentZoom = map.current.getZoom();
        console.log('[FiberPopMap] Zoom changed to:', currentZoom);

        // You can add zoom-based layer visibility logic here if needed
        // For example, show/hide markers based on zoom level
      };

      // Store handler in ref for proper cleanup
      zoomHandlerRef.current = handleZoomChange;
      map.current.on('zoom', handleZoomChange);

      // Expose map ref and methods to parent
      const updateMapRef = () => {
        if (setMapRef && map.current) {
          // Ensure clearHighlight ref is set
          if (!clearHighlightRef.current) {
            clearHighlightRef.current = clearHighlight;
          }

          // Create a ref-like object that exposes both the map and helper methods
          // Use arrow functions to ensure proper binding
          const mapRefObj = {
            current: map.current,
            triggerMarkerHighlight: (fiberPopName) => {
              if (highlightMarker) {
                highlightMarker(fiberPopName);
              }
            },
            clearHighlight: () => {
              console.log('clearHighlight called from mapRef', {
                hasRef: !!clearHighlightRef.current,
                hasHighlightedMarker: !!highlightedMarker.current,
              });
              // Use the ref to call clearHighlight function
              if (clearHighlightRef.current) {
                clearHighlightRef.current();
              } else {
                console.warn(
                  'clearHighlightRef.current is not available, calling clearHighlight directly'
                );
                // Fallback: call clearHighlight directly if ref is not set
                clearHighlight();
              }
            },
            flyTo: (options) => {
              if (map.current) {
                map.current.flyTo(options);
              }
            },
            clearAll: () => {
              clearAll();
            },
            cancelAllRequests: () => {
              cancelAllRequests();
            },
          };
          setMapRef(mapRefObj);
          console.log('Map ref updated with clearHighlight function', {
            hasClearHighlight: typeof mapRefObj.clearHighlight === 'function',
          });
        }
      };

      // Update map ref immediately
      updateMapRef();

      // Add Pakistan boundary layer when map loads
      map.current.on('load', () => {
        console.log('Map fully loaded, adding Pakistan boundary...');
        pakBoundryLayer(map.current, animationTimeoutRef);
        // Update map ref after map is fully loaded
        updateMapRef();

        // Resize map to ensure proper rendering (similar to IpranMap)
        if (map.current) {
          map.current.resize();
        }
      });

      // Also handle style.load as backup
      map.current.on('style.load', () => {
        console.log('Style fully loaded, adding Pakistan boundary...');
        pakBoundryLayer(map.current, animationTimeoutRef);
        // Update map ref after style is loaded
        updateMapRef();

        // Resize map to ensure proper rendering
        if (map.current) {
          map.current.resize();
        }
      });

      // Cleanup function
      return () => {
        // Cancel all ongoing requests
        cancelAllRequests();

        // Clear any pending animation timeouts
        if (animationTimeoutRef.current) {
          clearTimeout(animationTimeoutRef.current);
          animationTimeoutRef.current = null;
        }
        processedDataRef.current = null;
        removePopLayers();
        if (currentPopup.current) {
          currentPopup.current.remove();
        }
        if (highlightedPopup.current) {
          highlightedPopup.current.remove();
        }
        if (map.current) {
          // Remove zoom event listener with specific handler
          if (zoomHandlerRef.current) {
            map.current.off('zoom', zoomHandlerRef.current);
          } else {
            map.current.off('zoom');
          }
          map.current.remove();
          map.current = null;
        }
      };
    }
  }, [setMapRef]);

  // Handle selectedFiberPop changes (similar to IpranMap filter handling)
  useEffect(() => {
    if (!map.current) {
      return;
    }

    if (selectedFiberPop && fiberPopData.length) {
      highlightMarker(selectedFiberPop);
    } else if (!selectedFiberPop) {
      // Clear highlight when selectedFiberPop is empty
      console.log('[FiberPopMap] selectedFiberPop is empty, clearing highlight');
      // Only clear highlight - don't trigger flyTo here to avoid conflicts
      // The clearAll function or handleClear will handle the map animation
      clearHighlight();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiberPop, fiberPopData]);

  // Cleanup effect for request cancellation (similar to IpranMap)
  useEffect(() => {
    return () => {
      if (map.current) {
        // Remove zoom event listener with specific handler
        if (zoomHandlerRef.current) {
          map.current.off('zoom', zoomHandlerRef.current);
        } else {
          map.current.off('zoom');
        }
      }
      // Cancel all ongoing requests when component unmounts
      cancelAllRequests();
    };
  }, []);

  // Add markers when data is loaded and map is ready
  useEffect(() => {
    console.log('Marker useEffect triggered', {
      hasMap: !!map.current,
      dataLength: fiberPopData.length,
      isStyleLoaded: map.current?.isStyleLoaded?.(),
    });

    if (!map.current || !fiberPopData.length) {
      console.log('Marker useEffect: Missing map or data');
      return;
    }

    // Check if map is loaded
    if (map.current.loaded()) {
      console.log('Map is loaded, adding markers immediately');
      addPopLayers();
    } else if (map.current.isStyleLoaded()) {
      console.log('Map style is loaded, adding markers');
      addPopLayers();
    } else {
      console.log('Waiting for map to load...');
      // Wait for map to load
      const handleLoad = () => {
        console.log('Map load event fired, adding markers');
        if (map.current && (map.current.loaded() || map.current.isStyleLoaded())) {
          addPopLayers();
        }
      };

      map.current.once('load', handleLoad);
      map.current.once('style.load', handleLoad);

      // Cleanup: remove event listeners if component unmounts or data changes
      return () => {
        if (map.current) {
          map.current.off('load', handleLoad);
          map.current.off('style.load', handleLoad);
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fiberPopData]);

  return (
    <>
      <div
        ref={mapContainer}
        style={{
          width: '100%',
          height: '100%',
          minHeight: 'calc(100vh - 72px)',
        }}
      />
      <RefreshMap map={map} />
    </>
  );
};

export default FiberPopListMap;
